<template>
  <div class="text-center">
    <v-dialog width="500" value="true" @click:outside="$emit('close-dialog')">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Purchase {{nfts.size}} {{table}} NFT(s)
        </v-card-title>

        <v-card-text>
          <div id="nftsList">
            <span v-for="item in nfts.values()" :key="item.nftId">
              {{ item.nftId }} ({{ item.grouping.name }}): {{ item.price }} {{ item.priceSymbol }}
            </span>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions id="purchaseDetails">
            Total price: <span v-for="price in Object.keys(getPriceSum)" :key="price"> {{ price }}: {{getPriceSum[price]}} </span>
            <v-btn color="primary" text @click="purchaseSelected">Buy</v-btn>
            <v-btn color="red" text @click="$emit('close-dialog')">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import NftOperations from "../../mixins/NftOperations";

export default {
  props: ["table", "nfts", "user"],
  data () {
    return {
    }
  },
  mixins: [NftOperations],
  computed: {
    getPriceSum() {
      let sum = {};
      this.nfts.forEach(item => {
        if (!sum[item.priceSymbol]) {
          sum[item.priceSymbol] = 0;
        }
        sum[item.priceSymbol] += item.price;
      });
      return sum;
    }
  },
  methods: {
    purchaseSelected() {
      this.purchaseNfts(this.user, this.table, Array.from(this.nfts.keys())).then(res => {
        if (res.success) {
          this.$vToastify.success("Transaction successfully broadcasted!");
          this.$emit("nfts-purchased", Array.from(this.nfts.keys()));
          this.$emit('close-dialog');
        } else {
          this.$vToastify.error("Broadcasting transaction failed!");
          this.$emit("purchase-failed", Array.from(this.nfts.keys()));
        }
      });
    }
  }
}
</script>

<style scoped>
#nftsList {
  display: flex;
  flex-direction: column;
}

#purchaseDetails {
  display: flex;
  flex-direction: column;
}
</style>